import type { Receipt } from '@restaurant/shared';
import { esc, printHtml } from './printHtml';

/** Customer receipt for 80mm thermal printers. Same content as the WhatsApp PDF (buildReceipt). */
export function printReceipt(r: Receipt): void {
  const items = r.items
    .map(
      (i) =>
        `<tr><td>${i.quantity}×</td><td>${esc(i.name)}${i.details.map((d) => `<br><small>${esc(d)}</small>`).join('')}</td><td class="r">${esc(i.amount)}</td></tr>`,
    )
    .join('');
  const totals = r.totals
    .map((t) => `<tr${t.strong ? ' class="big"' : ''}><td>${esc(t.label)}</td><td class="r">${esc(t.amount)}</td></tr>`)
    .join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Receipt ${esc(r.receiptNo)}</title><style>
    @page{size:80mm auto;margin:0}
    body{font:12px/1.4 ui-monospace,Menlo,Consolas,monospace;width:72mm;margin:0 auto;padding:4mm 0;color:#000}
    h1{font-size:16px;margin:0;text-align:center} p{margin:1px 0} .c{text-align:center} .muted{font-size:11px}
    table{width:100%;border-collapse:collapse;margin:4px 0} td{vertical-align:top;padding:1px 0} td:first-child{padding-right:4px}
    .r{text-align:right;white-space:nowrap;padding-left:6px} hr{border:0;border-top:1px dashed #000;margin:6px 0} .big td{font-weight:700;font-size:14px}
  </style></head><body>
    <h1>${esc(r.restaurantName)}</h1>
    ${r.headerLines.map((l) => `<p class="c muted">${esc(l)}</p>`).join('')}
    <hr>
    <p class="c"><b>RECEIPT</b></p>
    <table><tr><td>Receipt</td><td class="r">${esc(r.receiptNo)}</td></tr>
    <tr><td>Order</td><td class="r">${esc(r.orderNumber)} · ${esc(r.orderType)}</td></tr>
    <tr><td>Date</td><td class="r">${esc(r.issuedAt)}</td></tr></table>
    ${r.customerLines.map((l) => `<p class="muted">${esc(l)}</p>`).join('')}
    <hr><table>${items}</table><hr>
    <table>${totals}<tr><td>Payment</td><td class="r">${esc(r.payment)}</td></tr></table>
    ${r.footer ? `<hr><p class="c">${esc(r.footer)}</p>` : ''}
  </body></html>`;
  printHtml(html);
}
